const initCategoriasTabs = () => {
  const tabsBoxes = document.querySelectorAll('[data-lista="editais"]');

  if (tabsBoxes.length) {
    tabsBoxes.forEach((tabsBox) => {
      const buttons = tabsBox.closest('.box-container')?.querySelectorAll('.box-button button');

      let isDragging = false;

      const handleClickButtonsArrows = () => {
        let scrollVal = Math.round(tabsBox.scrollLeft);
        let maxScrollableWidth = tabsBox.scrollWidth - tabsBox.clientWidth;

        if (buttons) {
          buttons[0].parentElement.style.display = scrollVal > 0 ? "flex" : "none";
          buttons[1].parentElement.style.display = maxScrollableWidth > scrollVal ? "flex" : "none";
        }
      };

      if (buttons) {
        buttons.forEach((btn) => {
          btn.addEventListener('click', () => {
            tabsBox.scrollLeft += btn.id === "anterior" ? -350 : 350;
            setTimeout(handleClickButtonsArrows, 50);
          });
        });
      }

      const dragging = (event) => {
        if (!isDragging) return;
        tabsBox.classList.add('dragging');
        tabsBox.scrollLeft -= event.movementX;
        handleClickButtonsArrows();
      };

      const dragStop = () => {
        isDragging = false;
        tabsBox.classList.remove('dragging');
      };

      tabsBox.addEventListener('mousedown', () => isDragging = true);
      tabsBox.addEventListener('mousemove', dragging);
      tabsBox.addEventListener('mouseup', dragStop);
      tabsBox.addEventListener('mouseleave', dragStop);
    });
  }
};

export default initCategoriasTabs;